import styled from "styled-components";

export const CaseInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    color: "#1e1e1e";
    `;

export const PaddingContainer = styled.div`
    padding: 0 28px;
    `;